import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class DateTimeValidatorService {
  constructor() {}
  // Start V2.0 Of Validations (All Formates Must Be In ISO Or UTC)
  DateTimeIntersected(startingDateTime: string, endDateTime: string, startingDateTimeCompare: string, endDateTimeCompare: string): Boolean {
    const notInter =
      (moment(startingDateTime).isBefore(startingDateTimeCompare) && moment(endDateTime).isSameOrBefore(startingDateTimeCompare)) ||
      (moment(endDateTime).isAfter(endDateTimeCompare) && moment(startingDateTime).isSameOrAfter(endDateTimeCompare));
    return !notInter;
  }
  DateTimeReservedByBetween(dateTime: string, startingDateTimeCompare: string, endDateTimeCompare: string): boolean {
    return moment(dateTime).isBetween(startingDateTimeCompare, endDateTimeCompare);
  }
  DateTimeReservedBySame(
    startingDateTime: string,
    endDateTime: string,
    startingDateTimeCompare: string,
    endDateTimeCompare: string
  ): boolean {
    return (
      (moment(startingDateTime).isSame(startingDateTimeCompare) || moment(startingDateTime).isSame(endDateTimeCompare)) &&
      (moment(endDateTime).isSame(startingDateTimeCompare) || moment(endDateTime).isSame(endDateTimeCompare))
    );
  }
  DateTimeReservedByAfterAndBefore(
    startingDateTime: string,
    endDateTime: string,
    startingDateTimeCompare: string,
    endDateTimeCompare: string
  ): boolean {
    return moment(startingDateTime).isBefore(startingDateTimeCompare) && moment(endDateTime).isAfter(endDateTimeCompare);
  }
  dateTimeEndIsAfterStart(startDateTime, endDateTime): boolean {
    return moment(endDateTime).isAfter(startDateTime);
  }
  // End V2.0 Of Validations
  // Compare Is The One That Will Change
  formater(dateTime: string, formatFrom: string, formatTo: string): string {
    return formatFrom !== null ? moment(dateTime, formatFrom).format(formatTo) : moment(dateTime).format(formatTo);
  }

  dateBetween(dateTime: string, startingDateTimeCompare: string, endDateTimeCompare: string): boolean {
    let isValid = true;
    if (moment(dateTime, 'YYYY-MM-DD HH:mm').isBetween(startingDateTimeCompare, endDateTimeCompare)) {
      isValid = false;
    }
    return isValid;
  }
  startAndEndDateValid(startingDateTime: string, endDateTime: string, isIso = false, fromat = 'YYYY-MM-DD HH:mm'): boolean {
    let isValid = true;
    if (isIso) {
      if (moment(startingDateTime).isAfter(endDateTime)) {
        isValid = false;
      }
    } else {
      if (moment(startingDateTime, fromat).isAfter(moment(endDateTime).format(fromat))) {
        isValid = false;
      }
    }
    return isValid;
  }
  startAndEndDateCover(
    startingDateTime: string,
    endDateTime: string,
    startingDateTimeCompare: string,
    endDateTimeCompare: string
  ): boolean {
    let isValid = true;
    if (
      moment(startingDateTime, 'YYYY-MM-DD HH:mm').isBefore(startingDateTimeCompare) &&
      moment(endDateTime, 'YYYY-MM-DD HH:mm').isAfter(endDateTimeCompare)
    ) {
      isValid = false;
    }
    return isValid;
  }
}
